<template>
  <div class="resourcePool">
    <!-- 顶部banner图 -->
    <div class="top-banner-box">
      <div class="top-banner-img" :style="{ backgroundImage: `url(${headerBgUrl})` }">
        <div class="top-banner-center">
          <div class="wow animate__animated animate__zoomIn banner-btn" @click="onClickLookMore">资源池</div>
        </div>
      </div>
    </div>
    <!-- 服务商分类+服务分类+专家数 -->
    <div class="serviceCon">
      <div v-for="(item, index) in serviceInfo" :key="index" class="serviceItem">
        <div class="serviceItem-bg" :style="{ backgroundImage: `url(${item.icon})` }"></div>
        <div class="serviceItem-con">
          <div class="serviceItem-con-num">
            {{ item.num
            }}
            <span style="font-size:15px;color:#000;margin-left:2px">个</span>
          </div>
          <div class="serviceItem-con-name">{{ item.name }}</div>
        </div>
      </div>
    </div>
    <!-- 细分领域服务商排行 + 服务能力 -->
    <rankAndAbility></rankAndAbility>
    <!-- 服务商 -->
    <serviceProvider></serviceProvider>
    <!-- 众多优质服务商提供数字化转型服务 -->
    <!-- <div class="transformService">
      <div class="box-title">众多优质服务商提供数字化转型服务</div>
      <div class="serviceBg-box">
        <div v-for="(item, index) in serviceList" :key="index" class="serviceItem"
          :style="{ backgroundImage: `url(${item.avatar})` }" @click="serviceDetail(item.uuid)"></div>
    </div>-->
    <div
      class="service-btn curp"
      @click="onClickProviderMore"
      style="margin: 0 auto;width: 100px;text-align: center;margin-bottom: 20px;"
    >查看更多</div>
    <!-- </div> -->
    <!-- 专家库 -->
    <!-- <div class="experts">
      <div class="experts-con">
        <div class="experts-con-title">
          专家库
        </div>
        <div class="experts-con-profile">{{ profile }}</div>
      </div>
    </div> -->
    <!-- 擅长领域 -->
    <greatField id="field" :title="title"></greatField>
    <div class="module" v-if="solutionList.length>0">
      <div class="module-title">产品及解决方案</div>
      <div class="product-content">
        <div class="product-item" v-for="item in solutionList" :key="item.uuid" @click="solutionDetail(item.uuid)">
          <div class="row">
            <div class="title" :title="item.title">{{ item.title }}</div>
            <div :class="{'btn':true, 'public': item.type == 'SPECIAL_SERVICE'?false:true}">{{ item.type == 'SPECIAL_SERVICE' ? '特色服务': '公共服务'}}</div>
          </div>
          <div class="row">
            <div class="text">
             {{ item.resolveDis}}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="module scene" v-if="caseList.length>0">
      <div class="module-title">典型案例&场景</div>
      <div class="module-content scene">
        <div :class="{'scene-item': true, 'active': activeCaseIdx==index}" v-for="(item, index) in caseList" :key="item.uuid"
                @mouseenter="setCaseActive(index)"
                @mouseleave="clearCaseActive(index)">
            <div class="img-wrap">
              <img :src="item.pic" alt="">
            </div>
            <div class="title" :title="item.title">{{item.title}}</div>
            <div class="text">
              {{item.description}}
            </div>
            <div class="btn" @click="caseDetail(item.uuid)">查看详情>></div>
            <div class="divider" v-if="index<3"></div>
        </div>
      </div>
    </div>
    <onlineCourse2></onlineCourse2>
  </div>
</template>

<script>
import {
  getDictionaryItem,
  getCount,
  getServiceSortCount,
  getServiceCount,
  getServiceIcon,
  getHomeCase,
} from "../../utils/interface";
import { digitalList } from "@/utils/honorApi";
import rankAndAbility from "./rankAndAbility";
import serviceProvider from "./serviceProvider";
import greatField from "./greatField";
import onlineCourse2 from '@/components/talentServices/onlineCourse2.vue'
export default {
  name: "",
  components: { rankAndAbility, serviceProvider, greatField, onlineCourse2 },
  props: {},
  data() {
    return {
      activeCaseIdx: 0,
      caseList: [], // 案例查询,
      solutionList: [], // 解决方案，
      headerBgUrl: "",
      serviceInfo: [
        {
          icon: require("../../assets/publicService/resourcePool/10.png"),
          name: "服务商总数",
          num: " "
        },
        {
          icon: require("../../assets/publicService/resourcePool/11.png"),
          name: "服务分类",
          num: " "
        },
        {
          icon: require("../../assets/publicService/resourcePool/12.png"),
          name: "专家数",
          num: " "
        }
      ],
      serviceList: [
        // { avatar: require('../../assets/publicService/resourcePool/21.png') },
        // { avatar: require('../../assets/publicService/resourcePool/22.png') },
        // { avatar: require('../../assets/publicService/resourcePool/23.png') }
      ],
      num: 168,
      profile:
        "汇聚一批不同行业、领域资深专家，充分发挥专家队伍的优势，为我区数字化\n" +
        "转型工作提供智力支持和技术保障，为政策制定、评估诊断、专项培训、供需\n" +
        "对接提供专业支撑，进一步促进我区新型工业化纵深发展",
      title: "",
      timer: null
    };
  },
  watch: {},
  computed: {},
  beforeRouteEnter(to, from, next) {
    // console.log("to=>", to)
    // console.log("from=>", from)
    // console.log("next=>", next)
    next(vm => {
      if (from.name == "expertDetail") {
        vm.$nextTick(() => {
          window.scrollTo({
            top: document.getElementById("field").offsetTop - 80,
            behavior: "smooth"
          });
        });
      }
    });
  },
  created() {
    this.getCaseList();
    this.getDigitalList();
    this.getOptionsData();
    this.getServiceCount(); // 获取服务商数量
    this.getServiceSortCount(); // 获取服务分类
    this.getCount(); // 获取专家个数
    this.getServiceIcon(); // 获取服务商图标信息
  },
  mounted() {
    window.addEventListener("scroll", this.menu);
    if (this.$route.query.type || this.$route.query.code) {
      let type = this.$route.query.type;
      let code = this.$route.query.code;
      if (type == "expert" || code == "2") {
        this.timer = setInterval(() => {
          // 直到顶部导航栏加载出来，再去做滑动操作，防止滑动后顶部导航栏颜色还是透明色
          let length = document.querySelectorAll(".changeColor").length;
          if (length > 0) {
            clearInterval(this.timer);
            window.scrollTo({
              top: document.getElementById("field").offsetTop - 80,
              behavior: "smooth"
            });
          }
        });
      }
    }
    if (this.$route.query.title) {
      this.title = this.$route.query.title;
      this.timer = setInterval(() => {
        // 直到顶部导航栏加载出来，再去做滑动操作，防止滑动后顶部导航栏颜色还是透明色
        let length = document.querySelectorAll(".changeColor").length;
        if (length > 0) {
          clearInterval(this.timer);
          window.scrollTo({
            top: document.getElementById("field").offsetTop - 80,
            behavior: "smooth"
          });
        }
      });
    }
  },
  methods: {
    getCaseList() {
      let params = {
        'rec1': '1'
      }
      getHomeCase(params).then(res => { // 案例场景
        this.caseList = (res || []).slice(0, 4);
      })
    },
    getDigitalList() {
      let params = {
        'rec1': '1'
      }
      digitalList(params).then(res => { // 案例场景
        console.log('digitalList'. res);
        this.solutionList = (res || []).slice(0, 5);
      })
    },
    caseDetail(uuid) {
      let routeData = this.$router.resolve({
        path: "/caseDetail",
        query: {
          uuid: uuid
        }
      });
      window.open(routeData.href, "_blank")
    },
    solutionDetail(uuid) {
      let router = this.$router.resolve({
        path: "/digServiceDetail",
        query: {
          uuid: uuid
        }
      });
      window.open(router.href, "_blank");
    },
    getOptionsData() {
      //顶部背景图
      getDictionaryItem({
        code: "ZYC_BANNER"
      }).then(res => {
        if (res != null && res.length > 0) {
          this.headerBgUrl = res[0].value;
        } else {
          this.headerBgUrl = "";
        }
      });
    },
    // 获取专家个数
    getCount() {
      getCount().then(res => {
        if (res) {
          this.serviceInfo[2].num = this.num = res;
        } else {
          this.serviceInfo[2].num = this.num = "";
        }
      });
    },
    // 获取服务分类
    getServiceSortCount() {
      getServiceSortCount().then(res => {
        if (res) {
          this.serviceInfo[1].num = res;
        } else {
          this.serviceInfo[1].num = "";
        }
      });
    },
    // 获取服务商数量
    getServiceCount() {
      getServiceCount().then(res => {
        if (res) {
          this.serviceInfo[0].num = res;
        } else {
          this.serviceInfo[0].num = "";
        }
      });
    },
    // 获取服务商图标信息
    getServiceIcon() {
      getServiceIcon({
        status: 1,
        rec: 1,
        programUuid: ""
      }).then(res => {
        if (res && res.length > 0) {
          this.serviceList = res;
        } else {
          this.serviceList = [];
        }
      });
    },
    onClickLookMore() {},

    //众多优质服务商-查看更多
    onClickProviderMore() {
      let route = this.$router.resolve({
        path: "/providerList"
      });
      window.open(route.href, "_blank");
    },
    // 获取服务商详情
    serviceDetail(uuid) {
      let routeData = this.$router.resolve({
        path: "/providerDetail",
        query: {
          uuid: uuid
        }
      });
      window.open(routeData.href, "_blank");
    },
    setCaseActive(index) {
      this.activeCaseIdx = index;
    }
  }
};
</script>
<style lang="less" scoped>
.resourcePool {
  position: relative;
  top: -80px;
  margin-bottom: -80px;

  .curp {
    &:hover {
      cursor: pointer;
      color: #2d50a1;
    }
  }

  .top-banner-box {
    .top-banner-img {
      height: 500px;
      width: 100%;
      overflow: hidden;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      display: flex;
      justify-content: center;
      align-items: center;

      .top-banner-center {
        width: 1300px;
        height: 370px;
        position: relative;
      }

      .banner-btn {
        width: 130px;
        margin-left: 20px;
        // background-color: white;
        color: transparent;
        letter-spacing: 2px;
        text-align: center;
        padding: 12px 0;
        border-radius: 7px;
        cursor: pointer;
        user-select: none;
        position: absolute;
        bottom: 104px;
        transition: all 0.2s;
      }
    }
  }

  .serviceCon {
    width: 1300px;
    height: 96px;
    margin: 0 auto;
    background-color: #fff;
    position: relative;
    top: -66px;
    border-radius: 8px;
    box-shadow: 0 0 8px #99999947;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: center;

    .serviceItem {
      width: 420px;
      height: auto;
      border-right: 1px solid #d5dcec;
      display: flex;
      flex-flow: row nowrap;
      justify-content: center;
      align-items: center;

      &:last-child {
        border-right: none;
      }

      .serviceItem-bg {
        width: 60px;
        height: 70px;
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }

      .serviceItem-con {
        display: flex;
        flex-flow: column nowrap;
        justify-content: center;
        align-items: center;
        margin-left: 20px;

        .serviceItem-con-num {
          color: #2d50a1;
          font-size: 30px;
          font-weight: 600;
        }

        .serviceItem-con-name {
          font-size: 17px;
          font-weight: 600;
        }
      }
    }
  }

  .box-title {
    font-size: 22px;
    font-weight: 600;
    text-align: center;
    margin: 0 auto;
    padding: 10px 0 15px;
  }

  .transformService {
    .serviceBg-box {
      width: 1300px;
      // height: 320px;
      min-height: 150px;
      margin: 0 auto;
      box-sizing: border-box;
      display: flex;
      flex-flow: row wrap;
      justify-content: center;
      align-items: stretch;

      .serviceItem {
        width: 165px;
        height: 75px;
        // box-shadow: 0 0 8px #99999947;
        background-size: 100% 100%;
        background-repeat: no-repeat;
        transition: all 0.2;
        margin: 5px;

        &:hover {
          transform: scale(1.05);
          cursor: pointer;
        }
      }
    }

    .service-btn {
      width: 135px;
      height: 34px;
      margin: 0 auto;
      margin-top: 10px;
      font-size: 14px;
      color: #fff;
      border-radius: 8px;
      box-sizing: border-box;
      text-align: center;
      line-height: 34px;
      margin-bottom: 20px;
      background-color: #2d50a1;
      cursor: pointer;
    }
  }

  .experts {
    height: 295px;
    background: url("../../assets/publicService/resourcePool/5.png") no-repeat
      center center/100% 100%;

    .experts-con {
      width: 1300px;
      margin: 0 auto;
      height: 100%;
      display: flex;
      flex-flow: column nowrap;
      justify-content: center;

      .experts-con-title {
        font-size: 28px;
        font-weight: 600;

        .experts-con-num {
          font-size: 22px;
          color: #2d50a1;
        }
      }

      .experts-con-profile {
        white-space: pre-wrap;
        margin-top: 15px;
        line-height: 2;
        font-weight: 500;
      }
    }
  }
}

.module {
  width: 100%;
  margin: auto;
  background-color: #fff;
  .module-title {
    font-size: 28px;
    font-weight: 600;
    text-align: center;
    margin: 20px 0;
  }
  .title {
    font-size: 24px;
    font-weight: bold;
    line-height: normal;
    letter-spacing: 0em;
    font-feature-settings: "kern" on;
    color: #2B2B2B;
  }
  &.scene {
    padding: 35px 0;
    width: 1300px;
    height: 367px;
    margin: auto auto 30px;
    border-radius: 12px;
    background: #F4F7FD;
    box-sizing: border-box;
    overflow: hidden;
    .module-title {
      margin: 0 0 25px;
    }
  }
  .product-content {
    padding-bottom: 10px;
    position: relative;
    width: 1300px;
    margin: auto !important;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .row {
      display: flex;
      justify-content: space-between;
      &:first-of-type {
        margin-bottom: 20px;
      }
    }
  }
  .module-content.scene {
    display: flex;
    .scene-item {
      position: relative;
      width: calc(25% - 1px);
      height: 250px;
      padding: 0 40px;
      // border-right: 1px solid #D8D8D8;
      display: flex;
      flex-direction: column;
      // justify-content: space-between;
      transition: all 0.3s ease;
      box-sizing: border-box;
      &.active {
        .img-wrap { 
          opacity: 1;
          max-height: 129px; // 与图片高度一致
        }
        .text {
          opacity: 0;
          max-height: 0;
        }
      }
      // &.index-0 {
      //   .img-wrap {
      //     opacity: 1;
      //     max-height: 129px; // 与图片高度一致
      //   }
      //   .text {
      //     opacity: 0;
      //     max-height: 0;
      //   }
      //   &:hover {
      //     .img-wrap {
      //       opacity: 0; max-height: 129px; // 与图片高度一致
      //       max-height: 0;
      //       margin: 0; // 可选：消除间距
      //     }
      //     .text {
      //         opacity: 1;
      //         max-height: fit-content;
      //     }
      //   }
      // }
      // &:hover {
      //   .img-wrap { 
      //     opacity: 1;
      //     max-height: 129px; // 与图片高度一致
      //   }
      //   .text {
      //     opacity: 0;
      //     max-height: 0;
      //   }
      // }
      .img-wrap {
        opacity: 0;
        max-height: 0;
        margin: 0; // 可选：消除间距
        overflow: hidden;
        transition: 
          opacity 0.4s ease,
          max-height 0.4s ease,
          margin 0.4s ease;
        img {
          width: 100%;
          display: block;
          width: 236px;
          height: 129px;
        }
      }
      .title {
        margin-bottom: 13px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .text {
        flex-grow: 1;
        opacity: 1;
         max-height: fit-content;
        overflow: hidden;
        font-size: 18px;
        font-weight: 350;
        transition: 
          opacity 0.4s ease,
          max-height 0.4s ease;
        // 用于多行省略（仅在显示时生效）
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 4;
        text-overflow: ellipsis;
      }
      .btn  {
        position: absolute;
        bottom: 0;
        margin: 14px 0;
        color: #2D50A1;
        font-size: 18px;
        font-weight: 350;
        cursor: pointer;
      }
      .divider {
        position: absolute;
        width: 1px;
        height: 180px;
        background-color: #D8D8D8;
        right: -1px;
        top: 20px;
      }
    }
  }
  .product-item {
    background: linear-gradient(90deg, #EEF4FF 0%, #F4F7FD 100%);
    box-sizing: border-box;
    border: 1px solid #FFFFFF;
    border-radius: 8px;
    width: calc(33% - 15px);
    height: 200px;
    margin-bottom: 20px;
    padding: 25px 30px;
    cursor: pointer;
    &:nth-of-type(1), &:nth-of-type(2) {
      width: calc(50% - 15px);
    }
    &:nth-of-type(4), &:nth-of-type(5) {
    
    }
    &:hover {
      box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.3);
    }
    .row .title {
      margin-right: 10px;
      flex-grow: 0;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .btn {
        flex-shrink: 0;
        width: 80px;
        height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        font-size: 16px;
        font-weight: 350;
        line-height: 1;
        background: linear-gradient(270deg, #FF0000 0%, #FF7B00 100%);
        box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05);
        box-sizing: border-box;
        border-radius: 302px;
        &.public {
          background: linear-gradient(270deg, #007BFF 0%, #00B7FF 100%);
        }
    }
    .text {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}

/deep/ .el-carousel__arrow--left {
  left: 90px;
}

/deep/ .el-carousel__arrow--right {
  right: 90px;
}
</style>



// WEBPACK FOOTER //
// src/components/resourcePool/index.vue